import { render } from "./OverlayRegister.vue?vue&type=template&id=34337968&ts=true"
import script from "./OverlayRegister.vue?vue&type=script&lang=ts"
export * from "./OverlayRegister.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__